import Clipboard from "clipboard";

const clipboard = new Clipboard(".clipboard");

clipboard.on("success", function (e) {
  const text = e.text.split("&")[0];
  const status = e.text.split("&")[1];
  $(".toast").html(text).addClass(status).fadeIn(300);
  e.clearSelection();
  setTimeout(function () {
    $(".toast").fadeOut(200);
  }, 2500);
});
